import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../config/colores'
import OperacionesCuposMultiples from '../containers/asignacionCupos/OperacionesCuposMultiples'
import CuposAUtilizar from '../containers/asignacionCupos/CuposAUtilizar'
import OperacionesNominacion from '../containers/asignacionCupos/OperacionesNominacion'

export const COLUMNS_DISPONIBLES = [
  {
    name: 'fechaDeEmision',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(f).format('DD/MM/YY')
        return <div>{fecha}</div>
      }
    }
  },
  {
    name: 'claveCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'tipo',
    label: 'Tipo',
    options: {
      filter: false,
      sort: false,
      customBodyRender: f => {
        const tipo = (f === 'Nominable' ? 'N' : 'L')
        return <div>{tipo}</div>
      }
    }
  },
  {
    name: 'cantidadAsignada',
    label: 'Asignados',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cantidadUsada',
    label: 'Utilizados',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cantidadDisponible',
    label: 'Disponibles',
    options: {
      filter: false,
      sort: true,
      customBodyRender: value => {
        let color
        if (value === 0) {
          color = COLORES.red.medium
        } else {
          if (value <= 10) {
            color = COLORES.blue.primary
          } else {
            color = COLORES.green.light
          }
        }
        return <div style={{ color: color, fontWeight: 'bold' }}>{value}</div>
      }
    }
  },
  {
    name: 'habilitado',
    label: ' ',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      filterType: 'checkbox',
      customBodyRender: value => {
        return <> </>
      }
    }
  },
  {
    name: 'cupo',
    label: 'A utilizar',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return <CuposAUtilizar cupo={value} />
      }
    }
  },
  {
    name: 'cupo',
    label: 'Acciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        return <OperacionesCuposMultiples cupo={value} tableMeta={tableMeta} updateValue={updateValue} />
      }
    }
  }
]

export const COLUMNS_NOMINADO_CACHE = [
  {
    name: 'fechaDeEmision',
    label: 'Fecha',
    options: {
      filter: false,
      sort: true,
      customBodyRender: f => {
        moment.locale('ar-AR')
        // Los cupos son los vigentes, no es necesario mostrar el año
        const fecha = moment(f).format('DD/MM/YY')
        return <div>{fecha}</div>
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'razonSocialCargador',
    label: 'Cargador',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cargador',
    label: 'cuitCargador',
    options: {
      filter: false,
      sort: false,
      display: false
    }
  },
  {
    name: 'razonSocialCorredor',
    label: 'Corredor',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'corredor',
    label: 'cuitCorredor',
    options: {
      filter: false,
      sort: false,
      display: false
    }
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'notificarCargador',
    label: 'Notif. Carg.',
    options: {
      filter: false,
      sort: true,
      customBodyRender: f => {
        const notificar = (f === true ? 'SI' : 'NO')
        return <div>{notificar}</div>
      }
    }
  },
  {
    name: 'notificarCorredor',
    label: 'Notif. Corr.',
    options: {
      filter: false,
      sort: true,
      customBodyRender: f => {
        const notificar = (f === true ? 'SI' : 'NO')
        return <div>{notificar}</div>
      }
    }
  },
  {
    name: 'exportador',
    label: 'Acciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        return <OperacionesNominacion id={value} tableMeta={tableMeta} />
      }
    }
  }
]
